import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import UserDropdown from 'components/AccountDropdown';
import UserDropdownReplica from 'components/AccountDropDownReplica';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import Divider from 'components/Divider';
import ToolTip from 'react-portal-tooltip';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import styles from './UserNavbar.scss';// to import local scss fle

class UserNavbar extends Component {
  static propTypes = {
    attributes: PropTypes.shape(),
    headerOnDashboard: PropTypes.bool,
    usedFor: PropTypes.string,
    match: PropTypes.shape.isRequired,
  };
  static defaultProps = {
    attributes: {},
    headerOnDashboard: false,
    usedFor: '',
  };
  constructor(props) {
    super(props);
    this.state = {
      profileIcon: '',
      isTooltipActive: false,
    };
    this.showTooltip = this.showTooltip.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
  }
  showTooltip() {
    this.setState({ isTooltipActive: true });
  }
  hideTooltip() {
    this.setState({ isTooltipActive: false });
  }
  render() {
    const { match } = this.props;
    let renderDropDownInSmall = false;
    if (window.innerWidth < 700) {
      renderDropDownInSmall = true;
    }
    const renderDropDownInSmallScreen = renderIf(renderDropDownInSmall);
    const renderDropDownInBigScreen = renderIf(!renderDropDownInSmall);
    const renderCoachItems = renderIf(this.props.attributes.get('zoneinfo') === 'COACH');
    const renderAthleteItems = renderIf(this.props.attributes.get('zoneinfo') === 'STUDENT');
    const renderAdminItems = renderIf(this.props.attributes.get('zoneinfo') === 'ADMIN');
    const renderHeaderonDashboard = renderIf(this.props.headerOnDashboard);
    const renderHeaderonProfilePage = renderIf(this.props.usedFor === 'profile_page');
    const dashboardOnSettings = renderIf(this.props.usedFor === 'settingsAthlete');
    const renderDropDown = renderIf(this.props.attributes.size > 0
      && match.params.id === undefined);
    const renderPublicNavLinks = renderIf(this.props.attributes.size === 0
      || match.params.id !== undefined);
    return (
      <div className={cn('row', styles.container)}>
        <div className={cn('col s4', styles.navBarLogo)}>
          <span>
            <Link to="/" >
              <img src="https://media.dev.myrecruitboard.com/Images/logo%402x.png" alt="logo" />
            </Link>
          </span>
        </div>
        <div className={cn('col s8', styles.navBarLinks)} >
          {renderPublicNavLinks(
            <span className={styles.displayInline}>
              <Link to="/">
                <button>HOME</button>
              </Link>
              <Link to="/about">
                <button>ABOUT</button>
              </Link>
              <Link to="/sports">
                <button>SPORTS</button>
              </Link>
              <Link to="/contact">
                <button>CONTACT</button>
              </Link>
            </span>,
                  )}
          {renderPublicNavLinks(
            <span>
              {/* eslint-disable*/}
              <xx
                  id="smallMenu"
                  onMouseEnter={this.showTooltip}
                  onMouseLeave={this.hideTooltip}
                  onClick={this.showTooltip}
                  className={styles.dropdownIconPublic}
                  src={this.state.profileIcon !== '' ?
                      `https://s3.amazonaws.com/myrbimagesdev/${this.state.profileIcon}` :
                      'https://media.dev.myrecruitboard.com/Images/defaultAthlete.png'}
                  alt="icon"
              >MENU</xx>

                {/* eslint-enable*/}

              <ToolTip active={this.state.isTooltipActive} position="bottom" arrow="right" parent="#smallMenu">
                <div className={styles.dropdownContainer}>
                  <span>
                    <Link to="/">
                      <button>HOME</button>
                    </Link>
                    <Divider />
                    <Link to="/about">
                      <button>ABOUT</button>
                    </Link>
                    <Divider />
                    <Link to="/sports">
                      <button>SPORTS</button>
                    </Link>
                    <Divider />
                    <Link to="/contact">
                      <button>CONTACT</button>
                    </Link>
                  </span>
                </div>
              </ToolTip>
            </span>,
                  )}
          {renderDropDown(
            <span >
              {/* <input type="text" placeholder="Search for athelete or coach" /> */}
              <Link to="/" className={styles.displayInline}>
                <button>HOME</button>
              </Link>
              {renderHeaderonDashboard(
                <div className={styles.displayInline}>
                  {renderAthleteItems(
                    <Link to="/view/athlete">
                      <button>PROFILE</button>
                    </Link>,
                                  )}
                  {/* {renderAdminItems( */}
                  {/* <Link to="/view/athlete"> */}
                  {/* <button>PROFILE</button> */}
                  {/* </Link>, */}
                  {/* )} */}
                  {dashboardOnSettings(
                    <Link to="/dashboard">
                      <button>DASHBOARD</button>
                    </Link>,
                                  )}
                </div>,
                          )}
              {renderHeaderonProfilePage(
                <div className={styles.displayInline}>
                  {renderAthleteItems(
                    <Link to="/dashboard">
                      <button>DASHBOARD</button>
                    </Link>,
                                  )}
                  {renderAdminItems(
                    <Link to="/dashboard">
                      <button>DASHBOARD</button>
                    </Link>,
                                  )}
                  {renderCoachItems(
                    <Link to="/settings">
                      <button>SETTINGS</button>
                    </Link>,
                                  )}
                </div>,
                          )}
              {renderDropDown(
                <a className={styles.dropdown}>
                  {renderDropDownInBigScreen(
                    <UserDropdown
                      {...this.props}
                      dropDownWithUser={this.props.headerOnDashboard}
                    />,
                                  )}
                  {renderDropDownInSmallScreen(
                    <UserDropdownReplica
                      {...this.props}
                      dropDownWithUser={this.props.headerOnDashboard}
                    />,
                                  )}
                </a>,
                          )}
            </span>,
                  )}
        </div>
      </div>
    );
  }
}


export default UserNavbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/UserNavbar.js